import React ,{useState}from "react";
import {Link} from "react-router-dom";
import * as Icons from "react-feather";
import {useAuth} from "store/auth";
import { toJalali } from "lib/helpers";
import Modal from "components/Modal";
import moment from "moment-jalaali";
import { Field, Form, Formik } from "formik";
import { dateTimeToserver,toDatePicker} from "lib/helpers";
import {
   Select,
   Loading
 } from "components/form";
import { PersianDataPicker } from "components/form";
import { useCore } from "store/core";
import { handleSuccessMessages } from "store/auth";
export default function CafeReport(props) {
   const auth = useAuth();
   const [cafePlanDetail,setCafePlanDetail]=useState(null);
   const [showPlanDetail,setShowPlanDetail]=useState(false);

   return (
      <>
      <ShowPlanDetail  show={showPlanDetail} setItem={(item)=>{setCafePlanDetail(item)}}  close={() => {
          setShowPlanDetail(false);
          auth.dispatch(auth.getDashboardData())
        }} item={cafePlanDetail}/>
         <div className="col-span-12 mt-8">
            <div className="intro-y flex items-center justify-between h-20">
               <h2 className="text-lg font-medium truncate mr-5">
               گزارش کافه
               </h2>
               
              
            </div>
            <div className="grid grid-cols-12 gap-6 mt-5">
               
               
            </div>
         </div>
         <div className="box col-span-12 overflow-auto lg:overflow-visible">
            <h2 className="m-2">برنامه های پخش شما</h2>
            <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
               <table className="table table-report -mt-2">
                  <thead>
                  <tr>
                     <th className="whitespace-nowrap text-center">شناسه</th>
                     <th className="whitespace-nowrap text-center">فیلم</th>
                     <th className="whitespace-nowrap text-center">زمان شروع</th>
                     <th className="whitespace-nowrap text-center">ظرفیت</th>
                     <th className="whitespace-nowrap text-center">ظرفیت باقی مانده</th>
                     <th className="whitespace-nowrap text-center">مشاهده جزییات</th>
                  </tr>
                  </thead>
                
                  <tbody>
                  {props.data.cafe_plans && props.data.cafe_plans.length > 0 && props.data.cafe_plans.map((item) => (
                  <tr className="intro-x">
                     <td className="w-16 text-center">
                        {item.id}
                     </td>
                     <td>
                        <div className="flex justify-center">
                          {item.product.detail.title}
                        </div>
                     </td>
                     <td>
                        <p className="font-medium whitespace-nowrap text-center">{toJalali(item.screening_start_at, "jYYYY-jMM-jDD HH:mm")}</p>
                     </td>
                     <td>
                        <div className="flex justify-center">
                          {item.capacity}
                        </div>
                     </td>
                    
                     <td>
                        <div className="flex justify-center">
                          {item.available}
                        </div>
                     </td>
                    
                     <td>
                     <div className="flex justify-center items-center">
                          <a
                            className="flex items-center ml-3 cursor-pointer"
                            onClick={() => {
                              setCafePlanDetail(item);
                              setShowPlanDetail(true);
                            }}
                          >
                            {" "}
                            <Icons.Eye className="w-4 h-4 ml-1" /> مشاهده جزییات
                          </a>
                        </div>
                     </td>
                  </tr>
                  ))}
                  </tbody>
               </table>
            </div>
         </div>

        
      </>
   );
}

export  function ShowPlanDetail(props) {
   const { show } = props;
   const core=useCore()
   const auth = useAuth();
   const [useList,setUseList]=useState([]);
   return (
     <>
       <Modal show={props.show} handleClose={props.close} title={props.title}>
         <div class="mt-3 text-center sm:mt-0 sm:mr-4 sm:text-right">
        
         <div className="box col-span-12 overflow-auto lg:overflow-visible">
            <h2 className="m-2">جزییات برنامه پخش</h2>
            <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
               <table className="table table-report -mt-2">
                  <thead>
                  <tr>
                     <th className="whitespace-nowrap text-center">مشتری</th>
                     <th className="whitespace-nowrap text-center">بلیت</th>
                     <th className="whitespace-nowrap text-center">وضعیت</th>
                     <th className="whitespace-nowrap text-center">عملیات</th>
                  
                  </tr>
                  </thead>
                
                  <tbody>
                  {props.item&&props.item.tickets && props.item.tickets.length > 0 && props.item.tickets.map((item) => (
                  <tr className="intro-x">
                   
                     <td>
                        <div className="flex justify-center">
                          {item.creator&&item.creator.full_name}
                        </div>
                     </td>
                     <td>
                        <p className="font-medium whitespace-nowrap text-center">{item.code}</p>
                     </td>
                     <td>
                        <p className="font-medium whitespace-nowrap text-center">{item.used==1||useList.includes(item.id)?'حاضر':"___"}</p>
                     </td>
                     <td>
                     <div className="flex justify-center items-center">
                          <button disabled={item.used==1||useList.includes(item.id)}
                            className="flex items-center ml-3 cursor-pointer"
                            onClick={() => {
                              core.dispatch(core.useCafeTicket(item.id,()=>{
                                 handleSuccessMessages('ثبت شد')
                                setUseList([...useList,item.id])
                              }))
                            }}
                          >
                            {" "}
                            <Icons.CheckCircle color={item.used==1||useList.includes(item.id)?'green':'red'} className="w-4 h-4 ml-1" /> ثبت حضور
                          </button>
                        </div>
                     </td>
                   
                  </tr>
                  ))}
                  </tbody>
               </table>
            </div>
         </div>
 
           <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            
             <button
               type="button"
               disabled={props.load}
               onClick={props.close}
               className="btn btn-outline-secondary w-20 mr-1"
             >
               بستن
             </button>
           </div>
         </div>
       </Modal>
     </>
   );
 }
 
